<template>
  <v-container>
    <v-card-title>
        <h2 class="primary--text">Dash Graph</h2>
    </v-card-title>
    <br/>
    <div v-if="loading">
      <Loading/>
    </div>
    <div v-else-if="!loading && isAdmin">
      <a href="/dashboard/adminBookings">
        <BarChart 
          :data="chartData()"
          :options="options" 
        >
        </BarChart>
      </a>
      <br/>
      <v-row justify="center">
        <v-col align="center">
          <v-btn 
          min-width="50%"
          depressed
          class="primary--text"
          to="/dashboard/deliveryBookings"
          > Deliveries </v-btn>
        </v-col>
        <v-col align="center">
          <v-btn 
          min-width="50%"
          depressed
          class="primary--text"
          to="/dashboard/exchangeBookings"
          > Exchanges </v-btn>
        </v-col>
        <v-col align="center">
          <v-btn 
          min-width="50%"
          depressed
          class="primary--text"
          to="/dashboard/collectionBookings"
          > Collections </v-btn>
        </v-col>
        <v-col align="center">
          <v-btn 
          min-width="50%"
          depressed
          class="primary--text"
          to="/dashboard/truckBookings"
          > Truck </v-btn>
        </v-col>
      </v-row>
    </div>
</v-container>
</template> 

<script>
import BarChart from "@/components/bookings/admin/BarChart";
import Loading from '@/components/Loading'
export default {
  name: 'AdminGraph',
  components: { BarChart, Loading },
  data() {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              display: true,
              ticks: {
                suggestedMin: 0,
                beginAtZero: true
              }
            }
          ]
        }
      }
    }
  },
  computed: {
    loading(){
      return this.$store.getters['admin/getLoading'];
    },
    isAdmin() {
      return this.$store.getters['auth/isAdmin'];
    },
    getData(){
      return this.$store.getters['admin/getData'];
    }
  },
  methods: {
    chartData(){
      if (!this.loading){
        return  {
          labels: ['Scheduling Delivery', 
                  'Scheduled Delivery', 
                  'Scheduling Exchange', 
                  'Scheduled Exchange', 
                  'Scheduling Colllection', 
                  'Scheduled Collection',
                  'Scheduling Truck',
                  'Scheduled Truck'
          ],
          datasets: [
            {
              label: 'Bookings',
              backgroundColor: '#F44336',
              data: this.getData
            }
          ]
        }
      }
     return null;
    }

  },
  async mounted (){
    await this.$store.dispatch('admin/fetchBookingGraphData'); 
  }
}
</script>

<style lang="scss" scoped>

</style>